"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const FormSection = ({ children, device, style }) => {
    return (React.createElement("div", { style: Object.assign({ marginBottom: 48, width: '100%', display: 'flex', flexDirection: 'column', padding: device !== 'Mobile' ? '0 32px' : '0 24px' }, style) }, children));
};
exports.default = FormSection;
